.footer {
  display: flex;
  flex-direction: row-reverse;
}
